import { Stack, Text } from "@mantine/core";

interface PreferredTimesDisplayProps {
  preferredTimes: string[];
  formatTime: (time: Date | string) => string;
  selectedDate?: string | null;
}

export const PreferredTimesDisplay = ({
  preferredTimes,
  formatTime,
  selectedDate,
}: PreferredTimesDisplayProps) => {
  return (
    <Stack gap="xs">
      <Text c="black" size="sm" fw={700}>
        선호 시간:
      </Text>
      {preferredTimes.length > 0 ? (
        <Stack gap="xs" pl="md">
          {preferredTimes.map((time, index) => {
            const isMatch = selectedDate && time === selectedDate;
            return (
              <Text
                key={index}
                c="black"
                size="sm"
                style={{
                  backgroundColor: isMatch ? "lightblue" : undefined,
                  padding: isMatch ? "2px 4px" : undefined,
                  borderRadius: isMatch ? "4px" : undefined,
                }}
              >
                • {formatTime(time)}
              </Text>
            );
          })}
        </Stack>
      ) : (
        <Text c="gray" size="sm" pl="md">
          시간 미정
        </Text>
      )}
    </Stack>
  );
};
